import styles from './Flexboxgrid.module.css';

export default function getClass(className: string) {
  return styles[className] || className;
}
